import React from 'react'
import styled from 'styled-components'
import AboutBanner from '../Components/aboutus/AboutBanner'
import AboutSection from '../Components/aboutus/AboutSection'
import Clients from '../Components/aboutus/Clients'
import OurGoals from '../Components/aboutus/OurGoals'

const AboutUs = () => {
    return (
        <div>
            <AboutBanner />
            <AboutSection />
            <OurGoals />
            {/* <Clients /> */}
        </div>
    )
}

export default AboutUs
